import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from '../atoms/ComponentBox/BoxWithIcon';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';
import fetchStatusCounts from '../GlobalFunction/Counts';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Location = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);

  const [counts, setCounts] = useState([]);

  // Parent ID for fetching status counts 
  const parentId = 33;

  // useEffect to fetch counts
  useEffect(() => {
    const getCounts = async () => {
      const data = await fetchStatusCounts(parentId);
      setCounts(data);
    };
    getCounts();
  }, [parentId]);

  // Function to find count data for a specific module by ModuleName
  const matchedItem = (moduleName) => {
    return counts.find(item => item.ModuleName === moduleName);
  };

  // Store matched count data for each module
  const matchCountry = matchedItem('Country Master');
  const matchState = matchedItem('State Master');
  const matchRegion = matchedItem('Region/Zone Master');
  const matchCity = matchedItem('City Master');
  const matchPincode = matchedItem('Pincode Master');

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === '1' ||
      modulePermission.EditRec === '1' ||
      modulePermission.DeleteRec === '1' ||
      modulePermission.ViewRec === '1'
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container sx={{
        width: '100%',
        maxWidth: '100%'
      }}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission('Country Master') && matchCountry && (
              <BoxWithIcon
                totalCount={matchCountry.TotalCount}
                activeCount={matchCountry.ActiveCount}
                inactiveCount={matchCountry.InactiveCount}
                link={{ pathname: '/countrytable' }}
                permissions={permissions}
                title='Country Master'
              />
            )}
            {hasModulePermission('State Master') && matchState && (
              <BoxWithIcon
                totalCount={matchState.TotalCount}
                activeCount={matchState.ActiveCount}
                inactiveCount={matchState.InactiveCount}
                link={{ pathname: '/statetable' }}
                permissions={permissions}
                title='State Master'
              />
            )}
            {hasModulePermission('Region/Zone Master') && matchRegion && (
              <BoxWithIcon
                totalCount={matchRegion.TotalCount}
                activeCount={matchRegion.ActiveCount}
                inactiveCount={matchRegion.InactiveCount}
                link={{ pathname: '/zonetable' }}
                permissions={permissions}
                title='Region/Zone Master'
              />
            )}
            {hasModulePermission('City Master') && matchCity && (
              <BoxWithIcon
                totalCount={matchCity.TotalCount}
                activeCount={matchCity.ActiveCount}
                inactiveCount={matchCity.InactiveCount}
                link={{ pathname: '/citytable' }}
                permissions={permissions}
                title='City Master'
              />
            )}
            {hasModulePermission('Pincode Master') && matchPincode && (
              <BoxWithIcon
                totalCount={matchPincode.TotalCount}
                activeCount={matchPincode.ActiveCount}
                inactiveCount={matchPincode.InactiveCount}
                link={{ pathname: '/pincodetable' }}
                permissions={permissions}
                title='Pincode Master'
              />
            )}
          </Grid>
          <Grid container spacing={1} sx={{ mt: 0 }}>

          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Location;